import * as blobUtil from 'blob-util';
import { forEach, pick } from 'lodash';
import { TYPE_VIDEO, TYPE_IMAGE } from './media-types';
import { requestFileUploadUrl } from './request-url';
const DEFAULT_ENCODING_OPTIONS = {
    encoding_options: {
        file_output: {
            video: { format: ['mp4', 'webm'] },
            audio: { format: 'm4a' },
        },
    },
};
const IMAGE_PROPERTIES = ['width', 'height', 'file_name', 'original_file_name'];
export const uploadFileToWixMediaAction = (file) => (dispatch, getState, { request }) => requestFileUploadUrl(request, file.name, file.type).then(({ credentials, metadata: { acl, path } }) => uploadFileV2({ file, credentials, name: file.name, acl, path }));
export const uploadFileToWixMedia = (requestFileUrl) => (file) => requestFileUrl(file.name, file.type).then(({ credentials, metadata: { acl, path } }) => uploadFileV2({ file, credentials, name: file.name, acl, path }));
export function uploadFile({ file, name, type, credentials: { uploadToken, uploadUrl }, folderId, }) {
    const formData = new FormData();
    let blob = file;
    try {
        blob = blobUtil.dataURLToBlob(blob);
    }
    catch (e) { }
    formData.append('file', blob, name);
    formData.append('upload_token', uploadToken);
    formData.append('parent_folder_id', folderId);
    formData.append('media_type', type);
    if (type === TYPE_VIDEO) {
        forEach(DEFAULT_ENCODING_OPTIONS, (value, key) => formData.append(key, value));
    }
    const request = new XMLHttpRequest();
    const promise = new Promise((resolve, reject) => {
        try {
            request.responseType = 'json'; // IE11 does not support responseType json
        }
        catch (error) { }
        request.addEventListener('load', (event) => {
            let data = event.target.response[0];
            try {
                data = JSON.parse(event.target.response)[0];
            }
            catch (error) { }
            if (type === TYPE_IMAGE) {
                data = pick(data, IMAGE_PROPERTIES);
            }
            resolve(data);
        });
        request.addEventListener('error', reject);
        request.open('POST', uploadUrl);
        request.send(formData);
    });
    return {
        xhr: request,
        promise,
    };
}
export function uploadFileV2({ file, name, path, acl, credentials: { token, url } }) {
    const formData = new FormData();
    let blob = file;
    try {
        blob = blobUtil.dataURLToBlob(blob);
    }
    catch (e) { }
    formData.append('file', blob, name);
    formData.append('uploadToken', token);
    formData.append('acl', acl);
    formData.append('path', path);
    const request = new XMLHttpRequest();
    const promise = new Promise((resolve, reject) => {
        try {
            request.responseType = 'json'; // IE11 does not support responseType json
        }
        catch (error) { }
        request.addEventListener('load', (event) => {
            const data = [event.target.response.payload].flat()[0];
            resolve(data);
        });
        request.addEventListener('error', reject);
        request.open('POST', url);
        request.send(formData);
    });
    return promise;
}
//# sourceMappingURL=upload-file.js.map